import React from 'react'
import { ClientSetting, clientSettings } from './settings'

type ClientSettingValue = ClientSetting

export const ClientSettingContext = React.createContext<ClientSettingValue>(clientSettings.default)
